export default __webpack_public_path__ + "static/media/Furu.3ab5fb57.jpg";